export default __webpack_public_path__ + "static/media/cern-italic.c8b6ec91.ttf";